@if(component && display && sku) {
<!-- Hold the slot at its final height only until Trustpilot has answered: the
     vendored widget reserves 24px until the iframe lands, which shifts everything
     below, but with noReviews=collapse the answer may be "nothing", and a fixed
     reservation would leave a blank gap the size of styleHeight. -->
<div [ngClass]="containerClass" [style.--trustpilot-slot-height]="component.styleHeight || '140px'">
    <trustpilot-widget [locale]="'en-US'"
                       [templateId]="component.templateId"
                       [businessunitId]="component.businessunitId"
                       [styleHeight]="component.styleHeight || '140px'"
                       [styleWidth]="component.styleWidth || '100%'"
                       [theme]="component.theme || 'light'"
                       [starColor]="'#fdb714'"
                       [noReviews]="'collapse'"
                       [sku]="sku"
                       [name]="product?.data?.name"
                       [reviewLanguages]="component.reviewLanguages || 'en'"
                       [availability]="product?.trustpilotAvailability"
                       [price]="product?.price"></trustpilot-widget>
</div>
}